module.exports = __webpack_public_path__ + "img/icon_back.ca82be8c.svg";